import axios from "axios";

// Wczytaj adres API z env, nigdy na sztywno
const API_URL =
  process.env.REACT_APP_API_URL ??
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000');

const api = axios.create({
  baseURL: API_URL,
  //withCredentials: true, // Jeśli chcesz cookies, jeśli nie – usuń tę linię
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Możesz tu dodać interceptor dla refresh tokena, jeśli będziesz go obsługiwać

export default api;
